import { APIService } from "./APIService"
import { DiscountType, FileType } from "./types"

const getDiscount = (code: string) =>
  APIService.get<null, DiscountType>(`/tools/discounts?code=${code}`)

const getCities = (countryCode: string, provinceCode: string) =>
  APIService.get<
    null,
    {
      name: string
      slug: string
    }[]
  >(`/tools/countries/${countryCode}/provinces/${provinceCode}/cities`)

const getCity = (countryCode: string, provinceCode: string, citySlug: string) =>
  APIService.get<
    null,
    {
      name: string
      slug: string
    }
  >(`/tools/countries/${countryCode}/provinces/${provinceCode}/cities/${citySlug}`)

const uploadCV = (file: any) => {
  const formData = new FormData()
  formData.append("file", file)

  return APIService.post<null, FileType>(`/tools/cv`, formData)
}

const countAccounts = (params: { country: string; province?: string | null }) =>
  APIService.get<null, number>(`/tools/count/accounts`, {
    params,
  })

const getTransactionsNotices = (locale: string) =>
  APIService.get<
    null,
    [
      {
        title: string
        content: string
      },
    ]
  >(`/tools/transactions/notices?locale=${locale}`)

export const ToolsService = {
  getDiscount,
  getCities,
  getCity,
  uploadCV,
  countAccounts,
  getTransactionsNotices,
}
